const ICON_RULES = [
  { pattern: /email|surel/i, icon: "far fa-envelope" },
  { pattern: /pasien|patient|dokter|doctor|pegawai|karyawan|employee|nama|\bname\b/i, icon: "far fa-user" },
  { pattern: /telepon|telephone|phone|mobile|whatsapp|\bwa\b|nomor hp/i, icon: "fas fa-phone-alt" },
  { pattern: /tanggal|date|lahir|birth/i, icon: "far fa-calendar-alt" },
  { pattern: /waktu|time|jam|slot|sesi/i, icon: "far fa-clock" },
  { pattern: /alamat|address|lokasi|location|kota|city|provinsi|province/i, icon: "fas fa-map-marker-alt" },
  { pattern: /ruangan|ruang|room/i, icon: "far fa-building" },
  { pattern: /password|kata sandi|sandi|pin/i, icon: "fas fa-lock" },
  { pattern: /nik|ktp|identitas|identity|nomor kartu|card number/i, icon: "far fa-id-card" },
  { pattern: /tindakan|layanan|service|action|prosedur|procedure/i, icon: "fas fa-hand-holding-medical" },
  { pattern: /pembayaran|payment|harga|price|nominal|amount|biaya|total/i, icon: "fas fa-wallet" },
  { pattern: /status/i, icon: "far fa-check-circle" },
  { pattern: /catatan|note|notes|keterangan|description|deskripsi|remark/i, icon: "far fa-sticky-note" },
  { pattern: /kode|code|barcode/i, icon: "fas fa-barcode" },
  { pattern: /website|url|tautan|link/i, icon: "fas fa-link" },
  { pattern: /dokumen|document|berkas|file|lampiran|attachment/i, icon: "far fa-file-alt" },
  { pattern: /cari|search/i, icon: "fas fa-search" },
];

const CONTROL_SELECTOR = [
  "input.form-control:not([type='hidden'])",
  "select.form-control",
  "select.custom-select",
  "textarea.form-control",
  ".vue-treeselect__control",
].join(",");

const ENHANCEMENT_SCOPE = "form, .modal";

let iconSequence = 0;

function fieldContext(control) {
  const group = control.closest(".form-group") || control.parentElement;
  const label = group && group.querySelector("label, legend");
  const input = control.matches(".vue-treeselect__control")
    ? control.querySelector("input")
    : control;

  return [
    label && label.textContent,
    input && input.id,
    input && input.name,
    input && input.getAttribute("placeholder"),
    input && input.getAttribute("aria-label"),
    input && input.getAttribute("autocomplete"),
    input && input.type,
  ]
    .filter(Boolean)
    .join(" ");
}

function iconFor(control) {
  const context = fieldContext(control);
  const rule = ICON_RULES.find(item => item.pattern.test(context));
  if (rule) return rule.icon;

  const input = control.matches(".vue-treeselect__control")
    ? control.querySelector("input")
    : control;
  if (input && input.type === "number") return "fas fa-hashtag";
  if (input && input.type === "email") return "far fa-envelope";
  if (input && (input.type === "tel" || input.type === "phone")) return "fas fa-phone-alt";

  return "fas fa-pen";
}

function hasExistingAddon(control) {
  const inputGroup = control.closest(".input-group");
  if (!inputGroup) return false;
  return Boolean(
    inputGroup.querySelector(
      ".input-group-prepend, .input-group-append, .input-group-text, .btn"
    )
  );
}

function hasStandaloneIcon(control) {
  const host = control.parentElement;
  if (!host) return false;

  return Array.from(host.children).some(child => {
    if (child === control || child.classList.contains("hc-form-field-icon")) return false;
    return (
      child.matches("i, svg, .input-icon, .field-icon, .form-icon") ||
      child.classList.contains("fa") ||
      child.classList.contains("fas") ||
      child.classList.contains("far")
    );
  });
}

function shouldSkip(control) {
  const input = control.matches(".vue-treeselect__control")
    ? control.querySelector("input")
    : control;
  const type = String((input && input.type) || "").toLowerCase();
  const excludedTypes = ["checkbox", "radio", "file", "color", "range", "submit", "button", "reset"];

  return (
    !input ||
    excludedTypes.includes(type) ||
    control.closest(".hc-no-form-icons, .custom-control, .form-check, .dataTables_filter") ||
    hasExistingAddon(control) ||
    hasStandaloneIcon(control)
  );
}

function removeEnhancement(control) {
  const iconId = control.getAttribute("data-hc-form-icon");
  const host = control.parentElement;
  if (iconId && host) {
    const icon = host.querySelector(`[data-hc-icon-id="${iconId}"]`);
    if (icon) icon.remove();
  }

  control.removeAttribute("data-hc-form-icon");
  control.classList.remove("hc-form-icon-control", "hc-form-control--placeholder");
  control.style.removeProperty("padding-left");

  if (control.matches(".vue-treeselect__control")) {
    const valueContainer = control.querySelector(".vue-treeselect__value-container");
    if (valueContainer) valueContainer.style.removeProperty("padding-left");
  }

  if (host && !host.querySelector(".hc-form-field-icon")) {
    host.classList.remove("hc-form-icon-host");
  }
}

function positionIcon(control, icon) {
  const host = icon.parentElement;
  if (!host || !control.isConnected) return;

  const height = control.getBoundingClientRect().height;
  const topInset = control.matches("textarea") ? 8 : Math.max(5, (height - 30) / 2);
  icon.style.left = `${control.offsetLeft + 8}px`;
  icon.style.top = `${control.offsetTop + topInset}px`;
}

function reserveIconSpace(control, icon) {
  const iconWidth = Number.parseFloat(window.getComputedStyle(icon).width) || 30;
  const textInset = Math.ceil(8 + iconWidth + 11);

  if (control.matches(".vue-treeselect__control")) {
    const valueContainer = control.querySelector(".vue-treeselect__value-container");
    if (valueContainer) {
      valueContainer.style.setProperty("padding-left", `${textInset}px`, "important");
    }
    return;
  }

  control.style.setProperty("padding-left", `${textInset}px`, "important");
}

function syncPlaceholderState(control) {
  if (control.matches(".vue-treeselect__control")) {
    const singleValue = control.querySelector(".vue-treeselect__single-value");
    const placeholderLike = Boolean(
      singleValue && /^(pilih|select)\b/i.test(singleValue.textContent.trim())
    );
    control.classList.toggle("hc-form-control--placeholder", placeholderLike);
    return;
  }

  if (!control.matches("select.form-control, select.custom-select")) return;

  const sync = () => {
    control.classList.toggle(
      "hc-form-control--placeholder",
      control.value === "" || control.value == null
    );
  };

  if (!control.hasAttribute("data-hc-placeholder-listener")) {
    control.addEventListener("change", sync);
    control.setAttribute("data-hc-placeholder-listener", "true");
  }
  sync();
}

function enhanceControl(control) {
  if (shouldSkip(control)) {
    if (control.closest(".hc-no-form-icons")) removeEnhancement(control);
    return;
  }

  const rect = control.getBoundingClientRect();
  if (rect.width < 120 || rect.height < 32) return;

  const host = control.parentElement;
  if (!host) return;

  let iconId = control.getAttribute("data-hc-form-icon");
  let icon = iconId && host.querySelector(`[data-hc-icon-id="${iconId}"]`);

  if (!icon) {
    iconId = `hc-form-icon-${++iconSequence}`;
    icon = document.createElement("span");
    icon.className = "hc-form-field-icon";
    icon.setAttribute("data-hc-icon-id", iconId);
    icon.setAttribute("aria-hidden", "true");
    icon.innerHTML = `<i class="${iconFor(control)}"></i>`;
    host.appendChild(icon);
    control.setAttribute("data-hc-form-icon", iconId);
  }

  host.classList.add("hc-form-icon-host");
  control.classList.add("hc-form-icon-control");
  reserveIconSpace(control, icon);
  syncPlaceholderState(control);
  positionIcon(control, icon);
}

function scanForms(root = document) {
  root.querySelectorAll("[data-hc-form-icon]").forEach(control => {
    if (!control.closest(ENHANCEMENT_SCOPE)) removeEnhancement(control);
  });

  root
    .querySelectorAll(
      CONTROL_SELECTOR.split(",")
        .flatMap(selector => [`form ${selector}`, `.modal ${selector}`])
        .join(",")
    )
    .forEach(enhanceControl);
}

export default function installFormFieldIcons() {
  if (typeof window === "undefined" || window.__MEDHOP_FORM_ICONS__) return;
  window.__MEDHOP_FORM_ICONS__ = true;

  let frame = null;
  const scheduleScan = () => {
    if (frame !== null) return;
    frame = window.requestAnimationFrame(() => {
      frame = null;
      scanForms(document);
    });
  };

  const observer = new MutationObserver(scheduleScan);
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["class"],
  });

  window.addEventListener("resize", scheduleScan, { passive: true });
  scheduleScan();
}
